export { default } from "./Slider";
